/**
 * copyToClipboard — veilige clipboard-copy met nette toast-feedback.
 * Voorkomt uncaught NotAllowedError (runtime-error-overlay) wanneer de
 * browser clipboard-permissie weigert; valt dan terug op execCommand.
 */
import { toast } from "sonner";
import i18n from "i18next";

export async function copyToClipboard(text, successMsg) {
    try {
        await navigator.clipboard.writeText(text);
        toast.success(successMsg || i18n.t("common.copied"));
    } catch {
        try {
            const ta = document.createElement("textarea");
            ta.value = text;
            ta.style.position = "fixed";
            ta.style.opacity = "0";
            document.body.appendChild(ta);
            ta.select();
            document.execCommand("copy");
            document.body.removeChild(ta);
            toast.success(successMsg || i18n.t("common.copied"));
        } catch {
            toast.error(i18n.t("common.copy_failed"));
        }
    }
}
